module.exports = __webpack_public_path__ + "img/p1.2108da47.jpg";